/**
 * @generated SignedSource<<9d4e5dc9997e6c7737cb1c9d7504ed35>>
 * @relayHash 9a3ba48c14fc58add9194c63108bdbe6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d0b844f60e6e7bfa3a6463524a4408120ad25642bbebaa3c9b6401fb5201031b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useAllCommentsDataQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null | undefined> | null | undefined;
  pageId: string;
};
export type useAllCommentsDataQuery$data = {
  readonly comments: {
    readonly __typename: "PaginatedCommentList";
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly __typename: string;
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly permissionType: SitePermissionType | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
        readonly type: string | null | undefined;
      };
      readonly body: {
        readonly value: string;
      };
      readonly container: {
        readonly id: string | null | undefined;
      };
      readonly contentStatus: string;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      };
      readonly location: {
        readonly __typename: string;
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null | undefined;
          readonly resolvedTime: AGG$Long | null | undefined;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly inlineText?: string | null | undefined;
        readonly type: string;
      };
      readonly parentId: string | null | undefined;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly reactionsSummary: {
        readonly ari: string;
        readonly containerAri: string;
        readonly reactionsCount: number;
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly count: number;
          readonly emojiId: string;
          readonly id: string;
          readonly reacted: boolean;
        } | null | undefined>;
      } | null | undefined;
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly __typename: string;
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly permissionType: SitePermissionType | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null | undefined;
          readonly webui: string | null | undefined;
        };
        readonly location: {
          readonly __typename: string;
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineMarkerRef?: string | null | undefined;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null | undefined;
            readonly resolvedTime: AGG$Long | null | undefined;
            readonly resolvedUser: string | null | undefined;
          } | null | undefined;
          readonly inlineText?: string | null | undefined;
          readonly type: string;
        };
        readonly parentId: string | null | undefined;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly reactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null | undefined>;
        } | null | undefined;
        readonly version: {
          readonly by: {
            readonly __typename: string;
            readonly displayName: string | null | undefined;
          } | null | undefined;
          readonly number: number | null | undefined;
          readonly when: string | null | undefined;
        };
      } | null | undefined>;
      readonly version: {
        readonly by: {
          readonly __typename: string;
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly friendlyWhen: string | null | undefined;
        readonly number: number | null | undefined;
        readonly when: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type useAllCommentsDataQuery = {
  response: useAllCommentsDataQuery$data;
  variables: useAllCommentsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = {
  "kind": "Variable",
  "name": "pageId",
  "variableName": "pageId"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v7 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "type"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v11 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v12 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v13 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v10/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v15 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "editui"
    },
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v17 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v18 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v19 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v20 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "commentResolveProperties",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/)
          ]
        }
      ],
      "type": "FooterComment"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "inlineMarkerRef"
        },
        {
          "concreteType": "InlineCommentResolveProperties",
          "kind": "LinkedField",
          "name": "inlineResolveProperties",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isDangling"
            },
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "inlineText"
        }
      ],
      "type": "InlineComment"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v22 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v23 = {
  "args": [
    {
      "kind": "Literal",
      "name": "childType",
      "value": "comment"
    },
    {
      "kind": "Literal",
      "name": "contentType",
      "value": "page"
    },
    (v2/*: any*/)
  ],
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "reactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "number"
},
v25 = {
  "kind": "ScalarField",
  "name": "when"
},
v26 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentStatus",
        "variableName": "contentStatus"
      },
      {
        "kind": "Literal",
        "name": "depth",
        "value": "ROOT"
      },
      (v2/*: any*/)
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ]
          },
          (v11/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "replies",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v9/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v24/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "friendlyWhen"
              },
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      (v4/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAllCommentsDataQuery",
    "selections": (v26/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAllCommentsDataQuery",
    "selections": (v26/*: any*/)
  },
  "params": {
    "cacheID": "9a3ba48c14fc58add9194c63108bdbe6",
    "id": "d0b844f60e6e7bfa3a6463524a4408120ad25642bbebaa3c9b6401fb5201031b",
    "metadata": {},
    "name": "useAllCommentsDataQuery",
    "operationKind": "query",
    "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
  }
};
})();

(node as any).hash = "e204d6ccc6fbeaaf6f5487808f864e6c";

export default node;
